<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2025-08-19 17:29:00
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-08-22 11:09:35
 * @FilePath: /epec-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/supplierListMaintenance/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
        <div class="flex-sb">
            <div>
                <!--          <eui-btn type="primary" @click="addSupplierVisible = true">供应商库添加</eui-btn>-->
                <eui-btn type="primary" @click="addSingleSupplierVisible = true">录入分供商</eui-btn>
                <eui-btn type="primary" @click="importSupplierVisible = true">批量录入分供商</eui-btn>
            </div>
            <div>
                <eui-btn type="primary" @click="handleExport">导出分供商清单</eui-btn>
            </div>
        </div>

        <tableList
        row-key="id"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
        class="margin-t10"
        :index-show="true"
      >
        <template #status="{ scope: { row } }">
          <eui-tooltip
            v-if="
              (row.status === 102 || row.status === 103) &&
              row.auditOptinion !== '' &&
              row.auditOptinion !== undefined
            "
            class="flex-all-center"
            :content="row.auditOptinion"
            placement="top"
          >
            <div class="flex-all-center">
              {{ formatStatus(row.status) }}
            </div>
          </eui-tooltip>
          <div v-else class="flex-all-center">
            {{ formatStatus(row.status) }}
          </div>
        </template>
        <template #fileName="{ scope: { row } }">
          <eui-btn type="link" @click="uploadDesc(row.ossUrl, row.fileName)">
            {{ row.fileName }}
          </eui-btn>
        </template>
        <template #operate="{ scope: { row } }">
          <eui-btn
            v-if="row.status === 102 || row.status === 103"
            type="text"
            @click="handleDel(row.applyId)"
            >删除</eui-btn
          >
        </template>
      </tableList>
      <div class="pagination flex-end">
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <!-- 供应商库添加 -->
      <batch-add-supplier-dialog
        v-if="addSupplierVisible"
        :addSupplierVisible.sync="addSupplierVisible"
      />
      <!-- 手动添加供应商 -->
      <add-single-supplier-dialog
        v-if="addSingleSupplierVisible"
        :addSingleSupplierVisible.sync="addSingleSupplierVisible"
        @handleAddSupplier="handleAddSupplier"
      />
      <!-- 批量上传 -->
      <import-template-dialog
              v-if="importSupplierVisible"
              :importVisible.sync="importSupplierVisible"
              dialog-title="批量录入分供商"
              down-load-file-name="分供商录入表.xlsx"
              down-load-method="excelDownSubSupplier"
              :file-url="fileUrl"
              template-name="供应商导入模板"
              tip-message="请先下载“供应商导入模板”，按模板格式填写信息，并完成上传。"
              @updatePage="handleImportSupplier"
      />
      <!-- 批量上传附件 -->
      <batch-upload-attchment-dialog
        v-if="batchUploadAttchmentVisible"
        :batchUploadAttchmentVisible.sync="batchUploadAttchmentVisible"
        :company-list="companyList"
        @handleConfirm="handleBatchUploadConfirm"
        @handleCancel="handleBatchUploadCancel"
      />
    </div>
  </div>
</template>

<script>
import utils from '@/modules/projectA/utils/utils.js';
import eSearch from '../../components/common/e-search';
import tableList from '../../components/common/e-table-list';
import batchAddSupplierDialog from './components/batchAddSupplierDialog';
import addSingleSupplierDialog from './components/addSingleSupplierDialog';
import importTemplateDialog from './components/importTemplateDialog';
import batchUploadAttchmentDialog from './components/batchUploadAttchmentDialog';
import api from '../../api/user';

export default {
  components: {
    eSearch,
    tableList,
    batchAddSupplierDialog,
    addSingleSupplierDialog,
    importTemplateDialog,
    batchUploadAttchmentDialog,
  },
  data() {
    return {
      checked: false,
      addSupplierVisible: false,
      addSingleSupplierVisible: false,
      importSupplierVisible: false,
      batchUploadAttchmentVisible: false,
      companyList: [],
      listTypeInfo: {
        statusList: [
          { id: null, name: '全部' },
          { id: 102, name: '生效' },
          { id: 101, name: '待审批' },
          { id: 103, name: '审批拒绝' },
        ],
      },
      filterInfo: {
        data: {
          status: null,
          subCompanyName: null,
        },
        fieldList: [
          {label: '分供商名称', type: 'input', value: 'subCompanyName'},
          {
            label: '状态',
            type: 'select',
            value: 'status',
            list: 'statusList',
          },
        ],
      },
      tableData: [],
      tableLabel: [
        {label: '分供商名称', param: 'subCompanyName', align: 'center'},
        { label: '状态', param: 'status', align: 'center', slot: 'status' },
        {
          label: '添加时间',
          param: 'createTime',
          align: 'center',
          width: '200',
        },
        {
          label: '供应商评价报告',
          param: 'fileName',
          align: 'center',
          width: '200',
          slot: 'fileName',
        },
        {
          label: '操作',
          param: '',
          align: 'center',
          slot: 'operate',
          width: '140',
        },
      ],
      queryData: {
        pageNum: 1,
        pageSize: 10,
        subCompanyName: null,
        status: null,
      },
      pageTotal: 0,
      fileUrl: api.batchImportSubSupplier,
    };
  },
  mounted() {
    this.querySupplierList();
  },
  methods: {
    async handleExport() {
      const res = await api.exportSubSupplier(this.queryData);
      if (res.type === 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '供应商信息导出');
      }
    },
    async handleBatchUploadConfirm(res) {
      console.log(res);
      const res1 = await api.batchAddSubSupplier(res);
      if (res1.code === '200') {
        this.$message.success('批量上传成功');
        this.querySupplierList();
        this.batchUploadAttchmentVisible = false;
      }
    },
    handleBatchUploadCancel() {
      this.batchUploadAttchmentVisible = false;
      this.querySupplierList();
    },
    handleImportSupplier(res) {
      this.importSupplierVisible = false;
      this.companyList = res;
      this.batchUploadAttchmentVisible = true;
    },
    handleAddSupplier() {
      this.addSingleSupplierVisible = false;
      this.querySupplierList();
    },
    async handleDel(applyId) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await api.deleteSubSupplier({ applyId });
        if (res.code === '200') {
          this.querySupplierList();
        }
      });
    },
    formatStatus(status) {
      const item = this.listTypeInfo.statusList.find(
        (item) => item.id === status
      );
      return item ? item.name : '';
    },
    async querySupplierList() {
      const res = await api.subSupplierList(this.queryData);
      if (res.code === '200') {
        const { records, total } = res.data;
        this.tableData = records || [];
        this.pageTotal = total || 0;
      }
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.querySupplierList();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.querySupplierList();
    },
    handleFilter(val) {
      this.queryData.subCompanyName = val.subCompanyName;
      this.queryData.status = val.status;
      this.queryData.pageNum = 1;
      this.querySupplierList();
    },
    handleReset() {
      this.queryData = {
        pageNum: 1,
        pageSize: 10,
        subCompanyName: null,
        status: null,
      };
      this.querySupplierList();
    },
    uploadDesc(fileUrl, fileName = '下载文件') {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
  },
};
</script>

<style scoped></style>
